export function whatsappStatusBadgeClass(status: string): string {
  switch (status) {
    case 'sent':
    case 'delivered':
    case 'read':
    case 'active':
      return 'border-transparent bg-emerald-50 text-emerald-700';
    case 'pending':
      return 'border-transparent bg-amber-50 text-amber-700';
    case 'failed':
      return 'border-transparent bg-red-50 text-red-700';
    case 'cancelled':
      return 'border-transparent bg-slate-100 text-slate-600';
    case 'logged_out':
    case 'disconnected':
      return 'border-transparent bg-slate-100 text-slate-500';
    default:
      return 'border-transparent bg-slate-100 text-slate-600';
  }
}

/** Human-readable label for message log status. */
export function formatWhatsappMessageStatus(status: string): string {
  switch (status) {
    case 'pending':
      return 'Menunggu';
    case 'sent':
      return 'Terkirim';
    case 'delivered':
      return 'Diterima';
    case 'read':
      return 'Dibaca';
    case 'failed':
      return 'Gagal';
    case 'cancelled':
      return 'Dibatalkan';
    default:
      return status;
  }
}

/** Human-readable label for WA session status. */
export function formatWhatsappSessionStatus(status: string): string {
  switch (status) {
    case 'active':
      return 'Terhubung';
    case 'pending':
      return 'Menunggu scan';
    case 'logged_out':
      return 'Sudah logout';
    case 'disconnected':
      return 'Terputus';
    default:
      return status;
  }
}

export function whatsappSessionStatusIcon(status: string): string {
  switch (status) {
    case 'active':
      return 'mdi:check-circle';
    case 'pending':
      return 'mdi:qrcode-scan';
    case 'logged_out':
      return 'mdi:logout-variant';
    case 'disconnected':
      return 'mdi:lan-disconnect';
    default:
      return 'mdi:help-circle-outline';
  }
}

/** Logout hanya relevan saat session masih hidup (active/pending). */
export function canLogoutWhatsappSession(status: string): boolean {
  return status === 'active' || status === 'pending';
}

export function formatWhatsappDatetime(iso?: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatWhatsappPhone(phone?: string | null): string {
  if (!phone) return 'Nomor belum tersedia';
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('62') && digits.length >= 11) {
    return `+${digits.slice(0, 2)} ${digits.slice(2, 5)}-${digits.slice(5, 9)}-${digits.slice(9)}`;
  }
  return phone;
}
